import { Injectable } from '@angular/core';
import { HttpRequestBody } from '../../interface/http-request';
import { HttpRequestService } from '../../http-request/http-request.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestServiceService {

  constructor(private httpRequestService: HttpRequestService) { }

  async login(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'login',
        data: reqData
      },
      log: 'login request initiated',
      error: 'login Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async socialLogin(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'social_login',
        data: reqData
      },
      log: 'login request initiated',
      error: 'login Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async slotClose(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'slot_close',
        data: reqData
      },
      log: 'slotClose request initiated',
      error: 'slotClose Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async reopenSlots(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'reopen_slots',
        data: reqData
      },
      log: 'slotClose request initiated',
      error: 'slotClose Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async signUp(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'signUp',
        data: reqData
      },
      log: 'SignUp request initiated',
      error: 'signUp Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async otp_Verify(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'otp_ver',
        data: reqData
      },
      log: 'Otp status altered',
      error: 'Otp status Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async otpResend(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'otp_resend',

        data: reqData
      },
      log: 'get otp resend request initiated',
      error: 'get otp resend Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async addResturantInfo(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'add_restro_info',
        data: reqData,

      },
      log: 'restro info request initiated',
      error: 'restro info request Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async updatePassword(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'update_password',
        data: reqData,

      },
      log: 'restro info request initiated',
      error: 'restro info request Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async resetPassword(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'reset_password',
        data: reqData,

      },
      log: 'restro info request initiated',
      error: 'restro info request Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async verifyEmail(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'otp_resend',
        data: reqData,

      },
      log: 'restro info request initiated',
      error: 'restro info request Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async updateResturantInfo(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'update_restro_info',
        data: reqData,

      },
      log: 'restro info request initiated',
      error: 'restro info request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async updateRestroPolicy(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'update_restro_policy',
        data: reqData,

      },
      log: 'restro policy update request initiated',
      error: 'restro policy update request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async addResturantslot(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'add_restro_slot',
        data: reqData,

      },
      log: 'restro slot request initiated',
      error: 'restro slot request Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async deleteAllSlots(reqData: any) {
    console.log(reqData);
    
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'delete_slot',
        data: reqData,
        // multipart: true

      },
      log: 'slot delete',
      error: 'slot delete',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async addResturantMenu(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'add_restro_menu',
        data: reqData,
        multipart: true

      },
      log: 'restro menu request initiated',
      error: 'restro menu request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getResturantData(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'get_retro_detail',
        data: {},
        queryParams: reqData

      },
      log: 'restro detail request initiated',
      error: 'restro detail request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getWebviewUrl() {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'webview_action',
        data: {},
       

      },
      log: 'webview action request initiated',
      error: 'webview action request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getSlotData(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'get_slot_list',
        data: {},
        queryParams: reqData

      },
      log: 'slot detail request initiated',
      error: 'slot detail request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async get14DaySlotData(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'get_14_slot_list',
        data: {},
        queryParams: reqData

      },
      log: '14 days slot detail request initiated',
      error: '14 days slot detail request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getClosedSlotData(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'get_closed_slot_list',
        data: {},
        queryParams: reqData

      },
      log: 'slot detail request initiated',
      error: 'slot detail request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getCussinesData() {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'cussines_Data',
        data: {},


      },
      log: 'cussions detail request initiated',
      error: 'cussions detail request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getDinningData() {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'dining_data',
        data: {},


      },
      log: 'dining detail request initiated',
      error: 'dining detail request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getAmenitiesData() {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'amenities_data',
        data: {},


      },
      log: 'amenities detail request initiated',
      error: 'amenities detail request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async removeImages(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'remove_images',
        data: reqData,


      },
      log: 'remove images request initiated',
      error: 'remove images request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async updateResturantData(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'update_restro_slot',
        data: reqData,

      },
      log: 'restro slot update request initiated',
      error: 'restro slot update request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async updateSingleSlotResturantData(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'update_single_restro_slot',
        data: reqData,

      },
      log: 'restro single slot update request initiated',
      error: 'restro single slot update request Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getReviewList(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'get_review_list',
        data: {},
        queryParams: reqData,

      },
      log: 'get review list request initiated',
      error: 'get review list request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async performReviewAction(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'perform_review_action',
        data: reqData,

      },
      log: 'perform review action request initiated',
      error: 'perform review action request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async sendEmail(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'send_reply',
        data: reqData,

      },
      log: 'send reply review action request initiated',
      error: 'send reply review action request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getBookingList(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'booking_list',
        data: {},
        queryParams: reqData
      },
      log: 'get booking list action request initiated',
      error: 'get booking list action request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getSlotDetailsList(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'slot_details_list',
        data: {},
        queryParams: reqData

      },
      log: 'get slot details list action request initiated',
      error: 'get slot details list action request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async updateBookingStatus(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'update_booking_status',
        data: reqData,

      },
      log: 'update booking status action request initiated',
      error: 'update booking status action request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async cancelledBookingList() {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'cancel_booking_list',
        data: {},

      },
      log: 'cancelled booking list  reason action request initiated',
      error: 'cancelled booking list  reason action request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async markNoShow(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'booking_no_show',
        data: reqData,

      },
      log: 'mark no show  action request initiated',
      error: 'mark no show action request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async getDashboardList(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'get_dashboard_list',
        data: {},
        queryParams: reqData,

      },
      log: 'get dashboard list request initiated',
      error: 'get dashboard list request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async addFCMToken(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'add_device_token',
        data: reqData,

      },
      log: 'add device token action request initiated',
      error: 'add device token action request Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getCountryList() {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'country_list',
        data: {},
        queryParams: '',

      },
      log: 'get country list request initiated',
      error: 'get country list request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async getLocationList() {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'location_list',
        data: {},
        queryParams: '',

      },
      log: 'get location list request initiated',
      error: 'get location list request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  private isRestaurantInfoSubmittedSubject = new BehaviorSubject<boolean>(false);
  isRestaurantInfoSubmitted$ = this.isRestaurantInfoSubmittedSubject.asObservable();
  private nicknameSubject = new BehaviorSubject<string>(''); // Initial value is an empty string
  public nickname$ = this.nicknameSubject.asObservable();
  private logoImageSubject = new BehaviorSubject<string>(''); // Initial value is an empty string
  public logoImage$ = this.logoImageSubject.asObservable();

  updateNickname(nickname: string) {
    this.nicknameSubject.next(nickname);
  }

  updatelogoImage(logo: string) {
    this.logoImageSubject.next(logo);
  }
  updateEndTime(time: any) {
    return time==='00:00'?'23:59':time
  }
  setRestaurantInfoSubmitted(isSubmitted: boolean): void {
    this.isRestaurantInfoSubmittedSubject.next(isSubmitted);
  }
  async getAddressFromLatLng(lat: any, long: any) {

    return await this.httpRequestService.getAddressFromLatLng(lat, long)
  }
  getRestaurantName(): any {

    return localStorage.getItem('resname') ? localStorage.getItem('resname') : 'N/A'
  }
  private reloadRequestedSource = new Subject<void>();
  reloadRequested$ = this.reloadRequestedSource.asObservable();
  requestReload(): void {
    this.reloadRequestedSource.next();
  }

  async getOperationalHours(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'operational_hours',
        data: {},
        queryParams: reqData,

      },
      log: 'get operational-hours list request initiated',
      error: 'get operational-hours list request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }

  async logout() {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'logout',
        data: {},
        queryParams: '',

      },
      log: 'logout request initiated',
      error: 'logout request Error',
      method: 'get'
    };
    return await this.httpRequestService.callHttp(body);
  }
  async addSlotOperational(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'add_slot_advance_operational',
        data: reqData,

      },
      log: 'restro info request initiated',
      error: 'restro info request Error',
      method: 'post'
    };
    return await this.httpRequestService.callHttp(body);
  }


  async addOperationalHours(reqData: any) {
    const body: HttpRequestBody = {
      option: {
        url: '',
        apigroup: 'auth',
        endpoint: 'add_types_timings',
        data: reqData,

      },
      log: 'restro operational-hours request initiated',
      error: 'restro operational-hours request Error',
      method: 'put'
    };
    return await this.httpRequestService.callHttp(body);
  }

}
